import { round } from './math';

export type Money = number;

const MONEY_PRECISION = 2;
const MONEY_MULTIPLIER = 10 ** MONEY_PRECISION;

export function strToMoney(value: string): Money {
  const parsed = parseFloat(value);

  return round(parsed * MONEY_MULTIPLIER, 0);
}

export function moneyToStr(value: Money): string {
  const parsed = value / MONEY_MULTIPLIER;

  return parsed.toFixed(MONEY_PRECISION);
}

export function formatMoney(value: Money, currencyCode: string, locale: string): string {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: MONEY_PRECISION,
    maximumFractionDigits: MONEY_PRECISION,
  }).format(value / MONEY_MULTIPLIER);
}
